module.exports = false;



//////////////////
// WEBPACK FOOTER
// /home/kepler/code/github/expense-manager-firebase/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0